
import React from 'react';

const ReferralPromoImage: React.FC = () => {
  return (
    <div className="py-0 bg-white">
      <div className="container mx-auto px-4 text-center">
        <img 
          src="/lovable-uploads/843f56a9-ea90-4bfc-9000-a1b7e1408a94.png" 
          alt="Referral Program Promotion" 
          className="max-w-full md:max-w-4xl mx-auto rounded-lg"
        />
      </div>
    </div>
  );
};

export default ReferralPromoImage;
